//站点卡片
const stationCardZh = {
  staCardLang: {
    站点卡片: '站点卡片',
    创建电站: '创建电站',
    全部: '全部',
    在线: '在线',
    离线: '离线',
    请选择地区: '请选择地区',
    查询: '查询',
    重置: '重置',
    搜索电站名称地址: '搜索电站名称地址',
    以下为: '以下为',
    的站点: '的站点',
    数量: '数量',
    进入电站: '进入电站',
    暂无站点图片: '暂无站点图片',
    装机容量: '装机容量',
    装机功率: '装机功率',
    编辑电站: '编辑电站',
    查看详情: '查看详情',
    投运时间: '投运时间',
    电站地址: '电站地址',
    查看电站: '查看电站',
    基础信息: '基础信息',
    更多信息: '更多信息',
    电站图片: '电站图片',
    电站名称: '电站名称',
    电站联系电话: '电站联系电话',
    安装图片: '安装图片',
    并网点信息: '并网点信息',
    有光伏: '有光伏',
    无光伏: '无光伏',
    有并网点: '有并网点',
    无并网点: '无并网点',
    其它: '其它',
    变压器信息: '变压器信息',
    站点变压器容量: '站点变压器容量',
    安装人: '安装人',
    安装人联系号码: '安装人联系号码',
    关闭: '关闭',
    中国: '中国',
    收起: '收起',
    打开: '打开'
  }
}
export default stationCardZh
